import {LoadingButton} from '@mui/lab';
import {
    Button,
    Chip,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import {DataGrid} from '@mui/x-data-grid';
import {useFormik} from 'formik';
import {useSnackbar} from 'notistack';
import {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import server from '../../../global/server';
import {useFetch} from '../../../hooks/useFetch';
import useHandleErrors from '../../../hooks/useHandleErrors';
import CustomerForm from '../components/CustomerForm';
import CustomerEditForm from '../components/CustomerEditForm';

export default () => {
    const navigation = useNavigate();
    const {data, mutate, error, isFetching} = useFetch('/person', {params: {type: 'business'}});
    const [viewDialog, setViewDialog] = useState(false);
    const [editCustomer, setEditCustomer] = useState();

    const columns = useMemo(() => [
        {field: 'id', headerName: 'ID', width: 50},
        {
            field: 'name',
            headerName: 'Cliente',
            flex: 1,
            minWidth: 250,
        },
        {
            field: 'document',
            headerName: 'Document',
            flex: 1,
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 1,
        },
        {
            field: 'phone',
            headerName: 'Telefone',
            flex: 1,
        },
        {
            field: 'actions',
            type: 'actions',
            renderCell: ({row}) => (
                <Button
                    onClick={e => {
                        setViewDialog(true);
                        setEditCustomer(row.id)
                    }}>
                    Alterar
                </Button>
            ),
        },
    ]);

    const handleClose = () => {
        setViewDialog(false);
        setEditCustomer();
    };
    return (
        <Container fixed>
            <Stack direction="row" alignItems="center" justifyContent="space-between" columnGap={2}>
                <Typography variant="h5" component="h2" my={3}>
                    Pacientes
                </Typography>
                <Button variant="contained" onClick={e => setViewDialog(true)}>
                    Adicionar paciente
                </Button>
            </Stack>
            <DataGrid autoHeight loading={isFetching} rows={data || []} columns={columns} />
            <Dialog
                components="form"
                open={viewDialog}
                onClose={handleClose}>
                
                {Boolean(editCustomer) ? (
                    <CustomerEditForm customer_id={editCustomer} mutateList={mutate} handleClose={handleClose} />
                ) : (
                    <>
                    <CustomerForm mutateList={mutate} setEditCustomer={setEditCustomer} handleClose={handleClose} />
                    </>
                )}
            </Dialog>
        </Container>
    );
};
